import type { FaireProductEntity } from "../../entity_types/product";

export const p_frhrms6u5e: FaireProductEntity = {
  token: "p_frhrms6u5e",
  type: "product",
  name: 'Fused Dots Bedside Carafe & Cup-8.5"H(24oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/87626376106007eff60eeecbbfc585df3991c89650fe28af96376abbb60fab91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ffe7bf8c217372bca13d979ef139a39e16ac96eeff0494b38dbb13a45bf4d837.jpeg",
    "https://cdn.faire.com/fastly/d43ed255fac11fdfd7ae3f473ee8f6dd28ee279cae16e0f2f694c54712b4e421.jpeg",
    "https://cdn.faire.com/fastly/74dfd822cf68c14bca55a64c923f0684bae5d713fd3864b2973402d9d8650141.jpeg",
    "https://cdn.faire.com/fastly/3a398211b2975befc420a707983a6a88a2e5450517539158b966192742172373.jpeg",
    "https://cdn.faire.com/fastly/f5931caffaee082bbb8ab2ab397c548eb32db6f59de7d3193ee04261744b2325.jpeg",
    "https://cdn.faire.com/fastly/d94f0387e61262f2abcbb7aed775ce626d810df1ffb629c695a428f4940746f6.jpeg",
    "https://cdn.faire.com/fastly/e5bc00a39552fe2a43efdd87da939f338b49b14d45acd311c9b31b45e803ef1d.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "Refresh your nightly routine with our Fused Dot Bedside Carafe & Cup – a chic and serene essential for any nightstand. This set includes a sleek carafe and matching glass that doubles as a lid, keeping your water clean and easily within reach. What truly sets it apart is the elegant fused-glass design, featuring soft, sea-glass-inspired dots available in amber or white. Hand wash only.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:17.300Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
